"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeaderEditConfig = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _pageLink = require("../page-link");

var _dropdownNav = _interopRequireDefault(require("./dropdown-nav"));

var _secondaryNavigation = _interopRequireDefault(require("./secondary-navigation"));

var _scrollEffect = require("./scroll-effect");

var _helpers = require("../../helpers");

var _lodash = require("lodash");

var _jsxFileName = "D:\\DXC\\Digital.UI.CommonStyling\\src\\lib\\components\\header\\index.jsx";
const HeaderEditConfig = {
  emptyLabel: "Header",
  isEmpty: function (props) {
    return !props || (!props.items || props.items.length < 1) && !props.secondaryLinkGroupList;
  }
};
/**
 * Farmlands common header component used on platforms
 */

exports.HeaderEditConfig = HeaderEditConfig;

const CommonHeader = props => {
  var _props$trackClick, _props$secondaryNavSi, _props$showSearch, _props$searchUrl, _props$SigninButton, _props$SigninButton2, _props$SignoutButton, _props$SigninButton3, _props$SigninButton4, _props$SignoutButton2, _props$LoadingPopUp, _props$AccountSwitchM, _props$RefreshPageMod;

  // Components/methods that will be the responsibility of the host application to pass through
  const trackClick = (_props$trackClick = props === null || props === void 0 ? void 0 : props.trackClick) !== null && _props$trackClick !== void 0 ? _props$trackClick : null;
  const SECONDARY_NAV_SIZE = (_props$secondaryNavSi = props === null || props === void 0 ? void 0 : props.secondaryNavSize) !== null && _props$secondaryNavSi !== void 0 ? _props$secondaryNavSi : 4;
  const [headerTransparent, setHeaderTransparent] = (0, _react.useState)(false);
  const [showHeader, setShowHeader] = (0, _react.useState)(true);
  const [toggleMenu, setToggleMenu] = (0, _react.useState)(false);
  const [secondaryLinks, setSecondaryLinks] = (0, _react.useState)();
  let showSearch = (_props$showSearch = props === null || props === void 0 ? void 0 : props.showSearch) !== null && _props$showSearch !== void 0 ? _props$showSearch : true;
  const searchUrl = (_props$searchUrl = props === null || props === void 0 ? void 0 : props.searchUrl) !== null && _props$searchUrl !== void 0 ? _props$searchUrl : "https://shop.farmlands.co.nz/search?q=";

  const searchTracking = searchInput => {
    Window.digitalData.event.push({
      eventName: "Search",
      eventAction: "Search",
      timeStamp: new Date(),
      location: document.location.href,
      attributes: {
        searchText: searchInput
      }
    });
    window.dispatchEvent(new CustomEvent("Search"));
  };

  function searchSubmit(e) {
    e.preventDefault();
    const searchText = e.target.searchText.value;
    searchTracking(searchText);
    window.location.href = searchUrl + searchText;
  }

  (0, _react.useEffect)(() => {
    var _props$USE_LINK;

    if (props !== null && props !== void 0 && props.domain) {
      window.AEM_URL = props === null || props === void 0 ? void 0 : props.domain;
    } else if (props !== null && props !== void 0 && props.AEM_URL) {
      window.AEM_URL = props === null || props === void 0 ? void 0 : props.AEM_URL;
    } else {
      window.AEM_URL = "https://farmlands.co.nz";
    }

    window.USE_LINK = (_props$USE_LINK = props === null || props === void 0 ? void 0 : props.USE_LINK) !== null && _props$USE_LINK !== void 0 ? _props$USE_LINK : false; // eslint-disable-next-line
  }, []);
  (0, _react.useEffect)(() => {
    transformSecondaryLinks();
  }, props === null || props === void 0 ? void 0 : props.items, props === null || props === void 0 ? void 0 : props.secondaryLinkGroupList, props === null || props === void 0 ? void 0 : props.secondaryNavSource);
  /* Render the back button */

  const contactUsIcon = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "Header__icon-ctn",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
      to: props.contactUsLink,
      className: "Header__icon-button",
      label: "Contact us",
      onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e, "Header Contact us"),
      onAuxClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e, "Header Contact us"),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "Header__contact-us-icon Header__icon",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 96,
        columnNumber: 11
      }
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "Header__tooltip",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 9
      }
    }, "Contact us"));
  }; // useScrollPosition(
  //   ({ prevPos, currPos }) => {
  //     // const isTranparent = -currPos.y < window.innerHeight - 80;
  //     const isTranparent = false;
  //     const isShow = currPos.y > prevPos.y;
  //     const isDesktop = window.innerWidth >= 901;
  //     if (isShow && isShow !== showHeader && isDesktop) setShowHeader(isShow);
  //     if (
  //       !isShow &&
  //       isShow !== showHeader &&
  //       isDesktop &&
  //       window.pageYOffset >= 155
  //     )
  //       if (props?.secondaryNavSource === true && window.pageYOffset >= 65) {
  //       }
  //     setShowHeader(isShow);
  //     if (
  //       isTranparent !== headerTransparent &&
  //       isDesktop &&
  //       window.pageYOffset >= 155
  //     )
  //       setHeaderTransparent(isTranparent);
  //   },
  //   [showHeader]
  // );


  (0, _scrollEffect.useScrollPosition)(_ref => {
    let {
      prevPos,
      currPos
    } = _ref;
    // const isTranparent = -currPos.y < window.innerHeight - 80;
    const isTranparent = false;
    const isShow = currPos.y > prevPos.y;
    const isDesktop = window.innerWidth >= 901;
    if (isShow !== showHeader && isDesktop) setShowHeader(isShow);
    if (isTranparent !== headerTransparent && isDesktop) setHeaderTransparent(isTranparent);
  }, [showHeader]);
  /* Render the hamburger menu icon */

  const toggleMenuIcon = () => {
    return /*#__PURE__*/_react.default.createElement("button", {
      className: "Header__icon-ctn Header__icon-button Header__tablet-icon",
      "aria-label": "Menu",
      onClick: toggleMenuState,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 145,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icons Header__icon ecom_toggle_menu_icon",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 150,
        columnNumber: 9
      }
    }, toggleMenu ? "close" : "menu"));
  };

  const logo = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "Logo",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 159,
        columnNumber: 7
      }
    }, props.logoLink ? /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
      to: props.logoLink,
      className: "Logo-link",
      label: "Logo",
      onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e, "Header Logo"),
      onAuxClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e, "Header Logo"),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 161,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "Logo-img",
      src: (0, _helpers.resolveAsset)(props === null || props === void 0 ? void 0 : props.logoSource),
      alt: "Farmlands SPA",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 168,
        columnNumber: 13
      }
    })) : /*#__PURE__*/_react.default.createElement("img", {
      className: "Logo-img",
      src: (0, _helpers.resolveAsset)(props === null || props === void 0 ? void 0 : props.logoSource),
      alt: "Farmlands SPA",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 11
      }
    }));
  };

  const navigationLinks = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "Header__nav-link-wrapper",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 187,
        columnNumber: 7
      }
    }, props.linkGroupList && props.linkGroupList.map(data => {
      return data.linkList.map((value, index) => {
        return /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
          to: value.path,
          key: index,
          className: "Header__nav-link",
          target: value.target,
          label: value.label,
          onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
          onAuxClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 192,
            columnNumber: 17
          }
        }, value.label);
      });
    }));
  };
  /* Toggle tablet menu */


  const toggleMenuState = () => {
    setToggleMenu(!toggleMenu);
  };

  const spacerClasses = (0, _classnames.default)("Header-spacer", {
    "Header-spacer--secondary": !props.thinHeader
  });

  function transformSecondaryLinks() {
    let secondaryLinks = [];

    if ((props === null || props === void 0 ? void 0 : props.secondaryNavSource) === "list") {
      let cloneList = (0, _lodash.clone)(props === null || props === void 0 ? void 0 : props.secondaryLinkGroupList);
      secondaryLinks = (0, _helpers.transformListLinks)(cloneList);
    } else if ((props === null || props === void 0 ? void 0 : props.secondaryNavSource) === "ecom") {
      let cloneEcom = (0, _lodash.clone)(props === null || props === void 0 ? void 0 : props.items);
      secondaryLinks = (0, _helpers.transformEcomLinks)(cloneEcom);
    } else {
      let clonePage = (0, _lodash.clone)(props === null || props === void 0 ? void 0 : props.items);
      secondaryLinks = (0, _helpers.transformPageLinks)(clonePage);
    }

    setSecondaryLinks(secondaryLinks);
  }

  const isEcom = (props === null || props === void 0 ? void 0 : props.wishListIconDesktop) && (props === null || props === void 0 ? void 0 : props.cartIcon) && (props === null || props === void 0 ? void 0 : props.wishListIconMobile);

  if (HeaderEditConfig.isEmpty(props)) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 243,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: `Header ${headerTransparent ? "Header__transparent" : ""} ${showHeader ? "" : "Header__hide"}`,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 244,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Header-container",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 248,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Header__left-ctn",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 249,
      columnNumber: 11
    }
  }, logo(), !props.thinHeader && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, navigationLinks())), !props.thinHeader && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("Header__side-btn-ctn", {
      "Header__side-btn-ctn--ecom": isEcom
    }),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 255,
      columnNumber: 15
    }
  }, !toggleMenu && props.isMobile && (props === null || props === void 0 ? void 0 : props.cartIcon), !toggleMenu && contactUsIcon(), toggleMenu && props.isAuthenticated && (props === null || props === void 0 ? void 0 : (_props$SigninButton = props.SigninButton) === null || _props$SigninButton === void 0 ? void 0 : _props$SigninButton.call(props)), toggleMenuIcon(), !(props !== null && props !== void 0 && props.isMobile) && /*#__PURE__*/_react.default.createElement("div", {
    className: "SigninButton-ctn",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 265,
      columnNumber: 19
    }
  }, props === null || props === void 0 ? void 0 : (_props$SigninButton2 = props.SigninButton) === null || _props$SigninButton2 === void 0 ? void 0 : _props$SigninButton2.call(props), props === null || props === void 0 ? void 0 : (_props$SignoutButton = props.SignoutButton) === null || _props$SignoutButton === void 0 ? void 0 : _props$SignoutButton.call(props)), (props === null || props === void 0 ? void 0 : props.isMobile) && props.isAuthenticated && !toggleMenu && (props === null || props === void 0 ? void 0 : (_props$SigninButton3 = props.SigninButton) === null || _props$SigninButton3 === void 0 ? void 0 : _props$SigninButton3.call(props))))), !props.thinHeader && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, toggleMenu && /*#__PURE__*/_react.default.createElement(_dropdownNav.default, {
    isAuthenticated: props.isAuthenticated,
    isAuthenicatedMenu: props.isAuthenticatedMenu,
    linkGroupList: props === null || props === void 0 ? void 0 : props.linkGroupList,
    secondaryLinkGroupList: secondaryLinks,
    header: { ...props
    },
    showSearch: showSearch,
    searchSubmit: searchSubmit,
    secondaryNavSource: props === null || props === void 0 ? void 0 : props.secondaryNavSource,
    SearchForm: props === null || props === void 0 ? void 0 : props.MobileSearchForm,
    trackClick: trackClick // cartIcon={props?.cartIcon}
    // wishListIconMobile={props?.wishListIconMobile}
    ,
    SigninButton: props === null || props === void 0 ? void 0 : (_props$SigninButton4 = props.SigninButton) === null || _props$SigninButton4 === void 0 ? void 0 : _props$SigninButton4.call(props),
    SignoutButton: props === null || props === void 0 ? void 0 : (_props$SignoutButton2 = props.SignoutButton) === null || _props$SignoutButton2 === void 0 ? void 0 : _props$SignoutButton2.call(props),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 281,
      columnNumber: 15
    }
  })), (props === null || props === void 0 ? void 0 : props.isMobile) && (props === null || props === void 0 ? void 0 : props.SearchForm) && /*#__PURE__*/_react.default.createElement("div", {
    class: "Header-container-secondary__mobile-search-container",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 301,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement("form", {
    className: "Header-container-secondary__text-field--form-mobile",
    id: "Header-container-secondary__text-field-form-mobile",
    onSubmit: searchSubmit,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 302,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: "Header-container-secondary__text-field-input-mobile",
    className: "Header-container-secondary__text-field",
    placeholder: "Search products",
    name: "searchText",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 307,
      columnNumber: 15
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "material-icons Header-container-secondary__search-icon",
    type: "submit",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 313,
      columnNumber: 15
    }
  }, "search"))), headerTransparent && showHeader && /*#__PURE__*/_react.default.createElement("hr", {
    className: "Line",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 322,
      columnNumber: 45
    }
  })), !props.hideSecondary && !props.thinHeader && /*#__PURE__*/_react.default.createElement(_secondaryNavigation.default, {
    items: secondaryLinks === null || secondaryLinks === void 0 ? void 0 : secondaryLinks.slice(0, SECONDARY_NAV_SIZE),
    showSearch: showSearch,
    searchSubmit: searchSubmit,
    SearchForm: props === null || props === void 0 ? void 0 : props.SearchForm,
    trackClick: trackClick,
    showHeader: showHeader,
    headerTransparent: headerTransparent,
    wishListIconDesktop: props === null || props === void 0 ? void 0 : props.wishListIconDesktop,
    cartIcon: props === null || props === void 0 ? void 0 : props.cartIcon,
    searchTracking: searchTracking,
    searchUrl: searchUrl,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 325,
      columnNumber: 9
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: spacerClasses,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 339,
      columnNumber: 7
    }
  }), props === null || props === void 0 ? void 0 : (_props$LoadingPopUp = props.LoadingPopUp) === null || _props$LoadingPopUp === void 0 ? void 0 : _props$LoadingPopUp.call(props), props === null || props === void 0 ? void 0 : (_props$AccountSwitchM = props.AccountSwitchModal) === null || _props$AccountSwitchM === void 0 ? void 0 : _props$AccountSwitchM.call(props), props === null || props === void 0 ? void 0 : (_props$RefreshPageMod = props.RefreshPageModal) === null || _props$RefreshPageMod === void 0 ? void 0 : _props$RefreshPageMod.call(props));
};

var _default = CommonHeader;
exports.default = _default;